export type TFacultyDiscount = {
  discount?: number | null
  faculty?: { slug?: string | null } | null
}

export type TDiscountCategory = {
  discount?: number | null
  facultyDiscount?: TFacultyDiscount[] | null
} | null

export type TDiscountFaculty = {
  slug?: string | null
  discount?: number | null
} | null

// Скидки не суммируются — берётся первая заданная по приоритету:
// формат программы → категория + направление → категория → направление
export const getEffectiveDiscount = ({
  formatDiscount,
  category,
  faculty
}: {
  formatDiscount?: number | null
  category?: TDiscountCategory
  faculty?: TDiscountFaculty
}): number | null =>
  formatDiscount ||
  category?.facultyDiscount?.find(
    item => !!item?.faculty?.slug && item.faculty.slug === faculty?.slug
  )?.discount ||
  category?.discount ||
  faculty?.discount ||
  null
